import { useTranslation } from 'react-i18next';
import './PublicPage.css';

export default function PrivacyPage() {
    const { t } = useTranslation();
    return (
        <div className="public-page privacy-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>{t('privacy_policy.hero_title')}</h1>
                    <p>{t('privacy_policy.hero_subtitle')}</p>
                </div>
            </header>

            <div className="legal-content-wrapper legal-text">
                <h2>{t('privacy_policy.s1_title')}</h2>
                <p>{t('privacy_policy.s1_text')}</p>

                <h2>{t('privacy_policy.s2_title')}</h2>
                <p>{t('privacy_policy.s2_text')}</p>

                <h2>{t('privacy_policy.s3_title')}</h2>
                <p>{t('privacy_policy.s3_text')}</p>

                <h2>{t('privacy_policy.s4_title')}</h2>
                <p>{t('privacy_policy.s4_text')}</p>
            </div>
        </div>
    );
}
